import { useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { getBackendBaseUrl } from "../utils/apiUrl";

const useApiFetcher = () => {
  //access the token from redux state
  const token = useSelector((state) => state.auth.token);
  const BASE_URL = getBackendBaseUrl();

  const apiFetcher = async (url, method = "GET", body = null, headers = {}) => {
    try {
      const config = {
        method,
        url: `${BASE_URL}${url}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
          ...headers,
        },
        ...(body !== null && { data: body }),
      };

      const response = await axios(config);

      if (response.data.success) {
        method !== "GET" && url !== '/track-progress' &&
          toast.success(response.data.message || "Request successful");
        return response.data.data;
      } else {
        if (url !== '/track-progress') {
          toast.error(response.data.message || "An error occurred");
        }
        return response.data.message;
        // throw new Error(response.data.message || "API Error");
      }
    } catch (error) {
      if (url !== '/track-progress') {
        toast.error(
          error.response?.data?.message ||
          "Something went wrong. Please try again."
        );
      }
      return error.response?.data?.message;

      // throw error;
    }
  };
  return { apiFetcher };
};

export default useApiFetcher;
